<template>
    <div class="img">
        <div class="logo">
            <div id="logo">
                <slot name="logoMobile">

                </slot>
            </div>
        </div>
        <div id="img">
            <slot name="img">

            </slot>
        </div>
    </div>
</template>